document.addEventListener("DOMContentLoaded", () => {

    const image = document.getElementById("aurasipVariantImage");

    if (!image) return;

    document.addEventListener("variant:change", function(event){

        if(!event.detail.variant) return;

        if(event.detail.variant.featured_media){

            image.src = event.detail.variant.featured_media.preview_image.src + "&width=350";

        }

    });

});